import { BusinessUnitERPKeyType, BusinessUnitKeyType, UnitOfMeasureType } from './api-shared.enums';
import { Surcharge } from './api-shared.models';
import { ConfirmationStatusType } from './order-confirmation.models';

export interface CreateOrderEntryHeaderRequest {
  CustomerId: string;
  DeliveryDate?: Date | string;
  PurchaseOrderNumber?: string;
}

export interface DeleteOrderEntryHeaderRequest {
  OrderEntryHeaderId: string;
}

export interface DeliveryDateResult {
  OrderEntryHeaderId: string;
  DeliveryDate: Date | string;
}

export interface FutureShipment {
  Products: Product[];
  ExpectedDeliveryDate: Date | string;
}

export interface GetCustomerOrderEntryHeadersRequest {
  customerId?: string;
}

export interface GetCustomersOrderEntryHeadersRequest {
  customerIds: string[];
}

export interface GetConfirmationOrderEntryHeadersRequest {
  customerId?: string;
  startDate: string;
  endDate?: string;
}

export interface GetFutureOrderEntryHeadersRequest {
  customerId?: string[];
}

export interface GetConfirmationOrderEntryHeaderByCustomersRequest {
  CustomerIds: string[];
  StartDate: string;
  EndDate: string | undefined;
  ConfirmationStatus: ConfirmationStatusType | undefined;
}

export interface GetMultipleShipmentsRequest {
  orderEntryHeaderId: string;
}

export interface GetOrderEntryHeaderRequest {
  orderEntryHeaderId: string;
}

export interface OrderEntryHeader {
  BusinessUnitKey: BusinessUnitKeyType;
  BusinessUnitERPKey: BusinessUnitERPKeyType;
  OrderEntryHeaderId: string;
  CustomerId: string;
  DeliveryDate: Date | string;
  PurchaseOrderNumber?: string;
  TotalQuantity: number;
  TotalLines: number;
  TotalExtendedItemPrice: number;
  Surcharges: Surcharge[];
  TotalOrderPrice: number;
  OrderEntryHeaderName?: string;
  ConfirmationOrderNumber?: string;
  CutoffDateTime: Date | string;
  MinimumOrderAmount: number;
  IsSubmitted: boolean;
  SubmittedDate?: Date | string;
  OrderByUserDisplay?: string;
  CustomerName?: string;
  CustomerNumber?: string;
  CustomerAddress?: string;
  CustomerCity?: string;
  CustomerState?: string;
  CustomerZip?: string;
  OperationCompanyName?: string;
  ConfirmationStatus: ConfirmationStatusType;
  CanDeleteOrder: boolean;
  CanViewOrderCutOff: boolean;
  OrderStatus?: number;
  OrderApprovalStatusType?: OrderApprovalStatusType;
  OrderSubmittedForReviewUserId?: string;
  OperationCompanyOrderTypeId?: string;
}

export enum OrderApprovalStatusType {
  None = 0,
  ReadyForReview = 1,
  Rejected = 2,
}

export interface OrderEntryHeaderName {
  OrderEntryHeaderId: string;
  OrderEntryHeaderName?: string;
}

export interface OrderEntryHeaders {
  ResponseObject: OrderEntryHeader[];
}

export interface Product {
  ProductDescription?: string;
  UnitOfMeasureType: UnitOfMeasureType;
}

export interface PurchaseOrderNumberResult {
  OrderEntryHeaderId: string;
  PurchaseOrderNumber?: string;
}

export interface SubmitOrderEntryHeaderRequest {
  OrderEntryHeaderId: string;
  TimeZone: string;
}
export interface SubmitOrderEntryHeaderToProcurementRequest {
  OrderEntryHeaderId: string;
  TimeZone: string;
}
export interface SubmitOrderEntryHeaderResultObject {
  AcceptOrder: boolean;
  RejectedMessage: string[];
  RedirectUrl: string;
}

export interface UpdateOrderEntryHeaderDeliveryDateRequest {
  OrderEntryHeaderId: string;
  DeliveryDate: Date | string;
}

export interface UpdateOrderEntryHeaderOrderEntryHeaderNameRequest {
  OrderEntryHeaderId: string;
  OrderEntryHeaderName?: string;
}

export interface UpdateOrderEntryHeaderPurchaseOrderNumberRequest {
  OrderEntryHeaderId: string;
  PurchaseOrderNumber?: string;
}

export interface GetActiveOrderRequest {
  CustomerId: string;
}

export interface GetActiveOrderResult {
  OrderEntryHeaderId?: string | null;
  DeliveryDate: Date | string;
  TotalQuantity: number;
}

export interface RecallFutureOrderRequest {
  OrderEntryHeaderId?: string | null;
  TimeZoneIdentifier: string;
}
export interface UpdateOrderEntryHeaderOperationCompanyOrderTypeRequest {
  OrderEntryHeaderId: string;
  OperationCompanyOrderTypeId?: string;
}
export interface UpdateOrderEntryHeaderOperationCompanyOrderTypeResult {
  OrderEntryHeaderId: string;
  OperationCompanyOrderTypeId?: string;
  DeliveryDate?: string | Date;
}
